import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { AlertsPageComponent } from './alerts.component';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: AlertsPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class AlertsPageRoutingModule {}
